import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { AuthService } from '@services/auth.service';

export const adminGuard: CanActivateFn = () => {
    const authService: AuthService = inject(AuthService);
    return authService.user.is_admin;
};
